/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateEnabledPayersBulkRequest
 */
export interface UpdateEnabledPayersBulkRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateEnabledPayersBulkRequest
     */
    payers_to_enable?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateEnabledPayersBulkRequest
     */
    payers_to_disable?: Array<string>;
}

/**
 * Check if a given object implements the UpdateEnabledPayersBulkRequest interface.
 */
export function instanceOfUpdateEnabledPayersBulkRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateEnabledPayersBulkRequestFromJSON(json: any): UpdateEnabledPayersBulkRequest {
    return UpdateEnabledPayersBulkRequestFromJSONTyped(json, false);
}

export function UpdateEnabledPayersBulkRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateEnabledPayersBulkRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'payers_to_enable': !exists(json, 'payers_to_enable') ? undefined : json['payers_to_enable'],
        'payers_to_disable': !exists(json, 'payers_to_disable') ? undefined : json['payers_to_disable'],
    };
}

export function UpdateEnabledPayersBulkRequestToJSON(value?: UpdateEnabledPayersBulkRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'payers_to_enable': value.payers_to_enable,
        'payers_to_disable': value.payers_to_disable,
    };
}

